export interface Channel {
  name: string
  number: number
  source: ChannelSource
  iconMediaId: string
}

export interface ChannelSource {
  name: string
  configuredChannelType: ChannelType
  channelNumber: number
  planTypes: ChannelPlanType[]
  purchasable: boolean
  resolution: ChannelResolution
  isRecordable: boolean
  isPauseLiveTvEnabled: boolean
  globalChannelId: string
}

export interface UDPChannel extends ChannelSource {
  ip: string
  port: number
  serviceId: number
  rtp: boolean
  drm: boolean
}

export interface DVBTChannel extends ChannelSource {
  freqHz: number
  serviceId: number
  bandwidthMHz: number
  dvbt2: boolean
  drm: boolean
}

export interface WebChannel extends ChannelSource {
  type: WebChannelSourceType
  url: string
}

export interface HDMIChannel extends ChannelSource {
  port: number
}

export enum ChannelCategory {
  ANIMATION,
  AUTO,
  BUSINESS,
  CHILDREN,
  CLASSIC,
  COMEDY,
  COOKING,
  CULTURE,
  DOCUMENTARY,
  EDUCATION,
  ENTERTAINMENT,
  FAMILY,
  GENERAL,
  KIDS,
  LEGISLATIVE,
  LIFESTYLE,
  MOVIES,
  MUSIC,
  NEWS,
  OUTDOOR,
  RELIGIOUS,
  RADIO,
  SCIENCE,
  SERIES,
  SHOP,
  SPECIALIST,
  SPORTS,
  TRAVEL,
  WEATHER,
  XXX,
}

export enum ChannelPlanType {
  CHKI = 'CHKI',
  CHKO = 'CHKO',
  DEFAULT = 'DEFAULT',
}

export enum ChannelResolution {
  HD,
  SD,
  UHD,
}

export enum ChannelType {
  UDP = 'UDP',
  DVBT = 'DVBT',
  WEB = 'WEB',
  HDMI = 'HDMI',
  RTP = 'RTP',
}

export enum WebChannelSourceType {
  HTTP,
  HLS,
}
